import { Dropdown } from 'react-bootstrap';
import FeatherIcon from 'feather-icons-react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import { useAuth } from 'hooks/useAuth';

const AdminProfileDropdownMenu = ({ className }: { className?: string }) => {
  const auth = useAuth();

  return (
    <Dropdown.Menu
      align="end"
      className={classNames(
        className,
        'navbar-top-dropdown-menu navbar-dropdown-caret py-2 dropdown-profile shadow border border-300'
      )}
    >
      <Dropdown.Item
        as={Link}
        to="/pages/plans-billing"
        className="d-flex align-items-center px-3 py-2"
      >
        <FeatherIcon icon="credit-card" size={16} className="me-2 text-700" />
        Plans &amp; Billing
      </Dropdown.Item>
      <Dropdown.Divider />
      <Dropdown.Item
        as="button"
        type="button"
        className="d-flex align-items-center px-3 py-2 text-danger"
        onClick={() => auth.handleSignOut()}
      >
        <FeatherIcon icon="log-out" size={16} className="me-2" />
        Sign out
      </Dropdown.Item>
    </Dropdown.Menu>
  );
};

export default AdminProfileDropdownMenu;
